import React, { CSSProperties } from 'react';
import { Avatar } from 'antd';
import { _getRandomAvatarColor, getAvatarName } from '../../../utils/_getAvatar';
import { IpoAvatarWrap } from './style';
import { getFileUrl } from '../../../utils/files';

interface IPAvatarProps {
	size?: number;
	shape?: 'square' | 'circle';
	info: {
		avatar?: null | string;
		name?: string;
		id: string;
		name2?: string;
		mobile?: string;
		baseUrl?: string;
	};
}

export const IPOAvatar = ({
	info: { avatar, name, name2, id, mobile, baseUrl },
	size = 20,
	shape = 'circle',
}: IPAvatarProps) => {
	type IShowType = {
		src?: string;
		style?: CSSProperties;
	};

	let showType: IShowType = {};

	if (!avatar) {
		showType.style = {
			backgroundColor: _getRandomAvatarColor(id),
			color: '#fff',
		};
	} else {
		showType.src = getFileUrl(baseUrl ?? '', avatar);
	}
	let otherProps = { shape, size };
	let props = { ...showType, ...otherProps };
	return (
		<IpoAvatarWrap fontSize={size}>
			<Avatar {...props}>
				{!avatar && (
					<span>
						{getAvatarName({ name: name ?? '', name2: name2 ?? '', mobile: mobile ?? '1' })}
					</span>
				)}
			</Avatar>
		</IpoAvatarWrap>
	);
};
